import React from 'react';
import { Box, Typography, Avatar, Tooltip } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { isAuthenticated, currentUser } = useAuth();
  
  // Get the first letter of user's name or email for the avatar
  const getInitial = () => {
    if (!currentUser) return '?';
    
    if (currentUser.full_name) {
      return currentUser.full_name.charAt(0).toUpperCase();
    } else if (currentUser.email) {
      return currentUser.email.charAt(0).toUpperCase();
    }
    
    return '?';
  };

  return (
    <Box
      component="header"
      sx={{
        py: 2,
        px: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Typography 
        variant="h4" 
        component="a" 
        href="/"
        sx={{ 
          fontWeight: 'bold', 
          color: 'grey.400',
          textDecoration: 'none',
        }}
      >
        Ualabi
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography 
          variant="h6"
          component="a" 
          href="/chat" 
          sx={{ 
            mx: 2, 
            color: 'text.primary', 
            textDecoration: 'none',
            '&:hover': { color: 'text.hover', textDecoration: 'underline' }
          }}
        >
          Chat
        </Typography>
        
        {/* New link to Docs page */}
        <Typography
          variant="h6"
          component="a"
          href="/docs"
          sx={{
            mx: 2,
            color: 'text.primary',
            textDecoration: 'none',
            '&:hover': { color: 'text.hover', textDecoration: 'underline' }
          }}
        >
          Documentos
        </Typography>
        
        {/* Show login link for non-authenticated users */}
        {!isAuthenticated && (
          <Typography 
            variant="h6"
            component="a" 
            href="/login" 
            sx={{ 
              mx: 2, 
              color: 'text.primary', 
              textDecoration: 'none',
              '&:hover': { color: 'text.hover', textDecoration: 'underline' }
            }}
          >
            Login
          </Typography>
        )}
        
        {/* Show register link for non-authenticated users */}
        {!isAuthenticated ? (
          <Typography 
            variant="h6"
            component="a" 
            href="/register" 
            sx={{ 
              mx: 2, 
              color: 'text.primary', 
              textDecoration: 'none',
              '&:hover': { color: 'text.hover', textDecoration: 'underline' }
            }}
          >
            Register
          </Typography>
        ) : (
          /* Show profile avatar and logout for authenticated users */
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Mi Perfil">
              <Avatar 
                component="a"
                href="/profile"
                sx={{ 
                  ml: 2,
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: 2
                  }
                }}
              >
                {getInitial()}
              </Avatar>
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Header;